module.exports = __webpack_public_path__ + "static/media/img-lang-zh-Hant.7e583e24.svg";